export default __webpack_public_path__ + "static/BannerGenericJsonItemsWithCharTitleAndDraftJsText-00601ee72ac152a91978740b9a015a14.jpg";